// import { cpus } from "os";

$(document).ready(function() {

// custom pie testGraphique

$('.js-pie').each(function(){
  var pie = $(this),
      values = pie.data('values'),
      labels = [],
      datas = [],
      colors = [],
      graphContainer = pie.parents('.js-graph-container'),
      legendContainer = graphContainer.find('.js-pie-legend');

  $.each(values, function () {
    datas.push(this.data);
    colors.push(this.color);
    labels.push(this.label);
    var legendData = pie.data('type') != undefined ? (this.data + ' ' + pie.data('type')) : this.data;
    legendContainer.append('<li><div class="graphContainer__labels__color" style="background-color:' + this.color + ';"></div>' + this.label + ' : ' + legendData + '</li>');
  });

  var myPieChart = new Chart(this,{
    type: 'pie',
    data: {
      labels: labels,
      datasets: [{
        backgroundColor: colors,
        label: labels,
        data: datas
      }]
    },

    options: {

      legend: {
        display: false,
      },

      elements: {
        arc: {
            borderWidth: 0
        }
      },

      tooltips: {
        enabled: true,
        bodyFontSize: 10,
        titleFontSize: 10,
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label[tooltipItem.index] || '';
            return label;
          }
        }
      },
    }
  });
})

// custom pie testGraphique

$('.js-pieNoHover').each(function(){
  var pie = $(this),
      values = pie.data('values'),
      labels = [],
      datas = [],
      colors = [],
      graphContainer = pie.parents('.js-graph-container'),
      legendContainer = graphContainer.find('.js-pie-legend');

  $.each(values, function () {
    datas.push(this.data);
    colors.push(this.color);
    labels.push(this.label);
    var legendData = pie.data('type') != undefined ? (this.data + ' ' + pie.data('type')) : this.data;
    legendContainer.append('<li><div class="graphContainer__labels__color" style="background-color:' + this.color + ';"></div>' + this.label + ' : ' + legendData + '</li>');
  });

  var myPieChart = new Chart(this,{
    type: 'pie',
    data: {
      labels: labels,
      datasets: [{
        backgroundColor: colors,
        data: datas
      }]
    },

    options: {
      legend: {
        display: false
      },

      elements: {
        arc: {
            borderWidth: 0
        }
      },

      tooltips: {
        enabled: false
      }
    }
  });
})

// custom radar testGraphique

$('.js-polarArea').each(function(){
  var radar = $(this),
      values = radar.data('values'),
      labels = [],
      colors = [],
      datas = [],
      graphContainer = radar.parents('.js-graph-container'),
      legendContainer = graphContainer.find('.js-pie-legend');

  $.each(values, function () {
    datas.push(this.data);
    labels.push(this.label);
    colors.push(this.color);
    var legendData = radar.data('type') != undefined ? (this.data + ' ' + radar.data('type')) : this.data;
    legendContainer.append('<li><div class="graphContainer__labels__color" style="background-color:' + this.color + ';"></div>' + this.label + ' : ' + legendData + '</li>');
  });

  var myRadarChart = new Chart(radar,{
    type: 'polarArea',
    data: {
      labels: labels,
      datasets: [{
        backgroundColor: colors,
        label: labels,
        data: datas
      }]
    },

    options: {

      legend: {
        display: false,
      },

      tooltips: {
        enabled: true,
        bodyFontSize: 16,
        titleFontSize: 16,
        callbacks: {
          label: function(tooltipItem, data) {

            var label = data.datasets[tooltipItem.datasetIndex].label[tooltipItem.index] || '';

            return label;
          }
        }
      },
      elements: {
        arc: {
            borderWidth: 1
        }
      },

      scale: {
        ticks: {
            display: false,
            max: 100
        },
      },
    }
  });
})

// line graphic

$('.js-lineGraphic').each(function(){
  var pie = $(this),
      values = pie.data('values'),
      datasets = [];
  
  $.each(values.datas, function () {
    datasets.push({
      label: this.label,
      backgroundColor: this.color,
      borderColor: this.color,
      data: this.data,
      fill: false,
    })
  });

  new Chart(this,{
    type: 'line',
    data: {
      labels: values.labels,
      datasets: datasets
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      },
      responsive: true,
      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label + ' : ' + tooltipItem.yLabel + ' %' || '';

            return label;
          }
        }
      },
      title: {
        display: true,
        text: values.title,
      },
    }
  });
})

// Stacked Bar graphic

$('.js-StackedBarGraphic').each(function() {
  var pie = $(this),
      values = pie.data('values'),
      datasets = [];

  $.each(values.datas, function () {
    datasets.push({
      label: this.label,
      backgroundColor: this.color,
      borderColor: this.color,
      data: this.data,
      fill: false,
    })
  });

  new Chart(this,{
    type: 'bar',
    data: {
      labels: values.labels,
      datasets: datasets,
    },
    options: {
      responsive: true,
      scales: {
        xAxes: [
          {
            stacked: true,
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
    },
  }
  );
});

});
